export default __webpack_public_path__ + "tmp_src/components/LightDarkText/LightDarkText.css.liquid";